export const TEST_IDS = {
    editSubstancesAndMedicalExams: {
        expositionType: 'editSubstancesAndMedicalExams-input-expositionType',
        substancesForms: {
            substanceFormFields: {
                expositionDateStart: 'editSubstancesAndMedicalExams-input-expositionDateStart',
                expositionDateEnd: 'editSubstancesAndMedicalExams-input-expositionDateEnd',
                medicalExams: 'editSubstancesAndMedicalExams-input-medicalExams'
            }
        }
    }
};